import { Route } from "react-router";

import { APP_BASE_HREF } from "../App";
import ModelsDetail from "../management/models/ModelsDetail";
import ModelsList from "../management/models/ModelsList";
import ModelsMap from "../management/models/ModelsMap";
import NewPersonalApiKey from "../management/personalApiKeys/NewPersonalApiKey";
import PersonalApiKeysList from "../management/personalApiKeys/PersonalApiKeysList";
import SchematisationsRedirectToLatest from "../management/schematisations/SchematisationRedirectToLatest";
import SchematisationsDetail from "../management/schematisations/SchematisationsDetail";
import SchematisationsList from "../management/schematisations/SchematisationsList";
import SimulationDetail from "../management/simulations/SimulationDetail";
import SimulationsLive from "../management/simulations/SimulationsLive";
import Usage from "../management/simulations/Usage";

import Home from "./Home";
import { tiles } from "./tiles";

// Returns route elements for use inside a layout route (no <Routes> wrapper, no catch-all).
// The * catch-all and NoMatchHandler live in App.tsx so the 404 page renders outside AppShell.
export function appRouteElements() {
  return (
    <>
      {Object.keys(tiles).map((url) => (
        <Route key={url} path={`${APP_BASE_HREF}${url}`} element={<Home />} />
      ))}

      <Route path={`${APP_BASE_HREF}/personal_api_keys/`} element={<PersonalApiKeysList />} />
      <Route path={`${APP_BASE_HREF}/personal_api_keys/new`} element={<NewPersonalApiKey />} />

      <Route path={`${APP_BASE_HREF}/simulations/`} element={<Usage />} />
      <Route path={`${APP_BASE_HREF}/simulations/:id`} element={<SimulationDetail />} />
      <Route path={`${APP_BASE_HREF}/live/`} element={<SimulationsLive />} />

      <Route path={`${APP_BASE_HREF}/schematisations`} element={<SchematisationsList />} />
      <Route
        path={`${APP_BASE_HREF}/schematisations/:id`}
        element={<SchematisationsRedirectToLatest />}
      />
      <Route
        path={`${APP_BASE_HREF}/schematisations/:id/:revisionId`}
        element={<SchematisationsDetail />}
      />

      <Route path={`${APP_BASE_HREF}/models`} element={<ModelsList />} />
      <Route path={`${APP_BASE_HREF}/modelsmap`} element={<ModelsMap />} />
      <Route path={`${APP_BASE_HREF}/models/:id`} element={<ModelsDetail />} />
    </>
  );
}
